import React, { useState } from 'react';

import Input from '../../Forms/Input';
import Button from '../../Forms/Button';

import StripeLogo from './assets/stripe_blurple';
import { PaymentMethodOption } from '../../../models/Stripe';
import './Account.payment.choose.scss';

interface AccountPaymentChooseProps {
    payMethod: PaymentMethodOption;
    handleMethodChange: (method: PaymentMethodOption) => void;
    requestMoreCredit: (paymentMethod: PaymentMethodOption, amount: number) => void;
    requestClose: () => void;
    loading?: boolean;
}

function AccountPaymentChooseView({
    payMethod,
    handleMethodChange,
    requestMoreCredit,
    requestClose,
    loading
}: AccountPaymentChooseProps) {
    const [amount, setAmount] = useState<number>(100);

    const handleAmountChange = (am: number) => {
        if (isNaN(am)) {
            setAmount(100);
        } else {
            const twoDecimal = parseFloat(am.toFixed(2));
            setAmount(twoDecimal);
        }
    }

    const checkBiggerThan = (am: number) => {
        console.log('AM: ', am);
        if (!am) {
            setAmount(100);
        } else if (am < 100) {
            setAmount(100);
        }
    }

    const onRequestMoreCredit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const amountVal = !amount ? 0 : amount as number;
        if (amountVal < 100) {
            // DO NOT ALLOW LESS THAN $100
            return;
        }
        requestMoreCredit(payMethod, amountVal);
    }

    const renderPaymentMethodOptionCards = () => {
        return (
            <div className='paymentOptionsWrapper'>
                <div className="paymentMethodOptions">
                    <button
                        className={`option_button ${payMethod === 'stripe' ? 'selected' : ''}`}
                        onClick={() => handleMethodChange('stripe')}
                        type="button"
                    >
                        <div className='method_option_card stripe'>
                            <div className='method_name'>
                                <p className='method_title'>
                                    Pago con <b>tarjeta</b> o <b>transferencia SPEI</b>
                                </p>
                                <div className='methodIcons'>
                                    <i className="material-icons">
                                        credit_card
                                    </i>
                                    <i className="material-icons">
                                        account_balance
                                    </i>
                                </div>
                            </div>
                            <div className='svgIcon'>
                                <StripeLogo width={60} className='gatewayIcon'/>
                            </div>
                        </div>
                    </button>
                </div>
            </div>
        )
    }

    const amountVal = !amount ? 0 : amount as number;

    return (
        <div id="AccountPaymentWithStripe">
            <div className="title">
                <h4>Agregar saldo de Pre-pago</h4>
            </div>
            <form onSubmit={onRequestMoreCredit} className="paymentForm">
                <Input
                    label="Saldo a agregar (mínimo $100 MXN)"
                    placeholder="Saldo a agregar"
                    value={amount}
                    onChange={handleAmountChange}
                    type="number"
                    onBlur={checkBiggerThan}
                    isCurrency={true}
                />
                {renderPaymentMethodOptionCards()}

                <div className='footNote'>
                    <p>
                        El saldo abonado no tiene vigencia y se utilizará para pagar las facturas emitidas y otros cargos asociados a tu cuenta hasta consumirse.
                    </p>
                    {
                        payMethod === 'mercadopago' ?
                        <p className='note'>
                            Comisión de Mercado Pago de $4.00 + 3.19% + IVA será aplicada al monto solicitado.
                        </p>
                        : null
                    }
                    {
                        payMethod === 'stripe' ?
                        <p className='note'>
                            Comisión de Stripe de $7.00 + IVA por SPEI o $3.00 + 3.6% + IVA por tarjeta será aplicada al monto solicitado.
                        </p>
                        : null
                    }
                    {
                        !payMethod ?
                        <p className='note'>
                            Comisiones aplicables varían según el proveedor o método de pago seleccionado.
                        </p>
                        : null
                    }
                </div>
                <Button 
                    type="submit" 
                    size='small'
                    primary={true} 
                    disabled={!payMethod || amountVal < 100 || loading} 
                    >
                    <span>
                        {
                            loading ? 'Procesando...' :
                            'Continuar con Stripe'
                        }
                    </span>
                </Button>
                <Button 
                    type="button" 
                    size='small'
                    tertiary={true} 
                    handleClick={requestClose} 
                    disabled={loading} 
                    >
                    <span>Cancelar</span>
                </Button>
            </form>
        </div>
    )
}

export default AccountPaymentChooseView;